// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContentPanel_contact__3JP8U","skilllist":"ContentPanel_skilllist__3fd87"};